import Services from './base-services'

const service = new Services('recommended')
import mapParameters from '../utils/map-parameters'

export default {
    getAllActive() {
        return service.get('getAllActive')
    },
    getActiveForUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getActiveForUser', params)
    },
    saveRecommendedBookUser(bookId: number|string, userId: number|string) {
        const params = {
            book: { id: bookId },
            user: { id: userId }
        }
        return service.post('saveRecommendedBookUser', params)
    }
}
